<template>
  <div>
    <div class="top-bg"></div>
    <div class="top-title">
      <div>
        <span>统一进件</span>
        <span>请选择您需要进件的产品</span>
      </div>
      <div>
        <img
          src="https://static.xchengtech.cn/5927dc560b8048dc87ede7a09c175670.png"
          alt=""
        />
      </div>
    </div>
    <div class="content">
      <van-empty v-show="productList.length === 0" description="暂无产品" />
      <div
        class="item"
        @click="toUrl(item.id)"
        v-for="(item, index) in productList"
        :key="index"
      >
        <span>{{ item.productName }}</span>
        <img
          src="https://static.xchengtech.cn/78e46490437144298c6ece4a7ad83a96.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Empty, Toast } from "vant";
import Vue from "vue";
import { xcProductDict } from "@/api/product.js";
import { getCurrentChannelInfo } from "@/api/login.js";
Vue.use(Empty);
export default {
  created() {
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: "加载中",
    });
    // 获取渠道用户信息
    getCurrentChannelInfo()
      .then((res) => {
        this.channelInfo = res;
        // 获取产品列表
        this.getProductList();
      })
      .catch((err) => {
        console.log("err", err);
        Toast.clear();
      });
  },
  data() {
    return {
      channelInfo: {},
      productList: [],
    };
  },

  mounted() {},

  methods: {
    // 获取产品列表
    getProductList() {
      xcProductDict()
        .then((res) => {
          this.productList = res;
          Toast.clear();
          console.log("this.productList", this.productList);
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    // 前往进件页面
    toUrl(productId) {
      let url =
        "https://apply.xchengtech.cn/#/apply?productId=" +
        productId +
        "&channelId=" +
        this.channelInfo.id;
      window.location.href = url;
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/productSummary/index.vue